import React from 'react'
import { Alert, Box, Typography } from '@mui/material'

// Pieces shared by the influencer pages; the cards, tiles and buttons
// themselves come from components/UI/Depth like the rest of the panel.

export const money = value => `£${Number(value || 0).toFixed(2)}`

const pillTones = {
  green: ['rgba(21,128,61,0.1)', '#15803D'],
  amber: ['rgba(217,119,6,0.12)', '#B45309'],
  rose: ['rgba(190,18,60,0.1)', '#BE123C'],
  blue: ['rgba(47,95,224,0.1)', '#2F5FE0'],
  slate: ['rgba(51,65,85,0.08)', '#475569']
}

/** Small rounded status label for table cells and card headers. */
export const StatusPill = ({ tone = 'slate', icon: Icon, children }) => {
  const [bg, fg] = pillTones[tone] || pillTones.slate
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.25,
        py: 0.35,
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        bgcolor: bg,
        color: fg
      }}>
      {Icon ? <Icon sx={{ fontSize: 15 }} /> : null}
      {children}
    </Box>
  )
}

/** Label above a form control, in the panel's muted caption style. */
export const FieldLabel = ({ children }) => (
  <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>
    {children}
  </Typography>
)

/** Success / error line under a form. Renders nothing when both are empty. */
export const FormFeedback = ({ success, error }) =>
  success || error ? (
    <Alert
      severity={error ? 'error' : 'success'}
      sx={{ mt: 2, borderRadius: '12px' }}>
      {error || success}
    </Alert>
  ) : null
